import { FC, useState } from 'react';
import { EMode } from 'common/const/common.enum';
import { LegalEntityContext } from 'common/context/legalEntity/legalEntity.context';

export interface IComponentProps {
  children: React.ReactNode;
}

export const LegalEntityProvider: FC<IComponentProps> = ({ children }) => {
  const [editLegalEntityCardMode, setEditLegalEntityCardMode] = useState<EMode>(EMode.Create);
  const [openLegalEntityCard, setOpenLegalEntityCard] = useState<boolean>(false);
  const [openEditLegalEntityCard, setOpenEditLegalEntityCard] = useState<boolean>(false);

  return (
    <LegalEntityContext.Provider
      value={{
        editLegalEntityCardMode,
        setEditLegalEntityCardMode,
        openLegalEntityCard,
        setOpenLegalEntityCard,
        openEditLegalEntityCard,
        setOpenEditLegalEntityCard,
      }}
    >
      {children}
    </LegalEntityContext.Provider>
  );
};
